import { TranslationsContext } from '@telia-common-components/shared';
import * as React from 'react';
import { useInternetOffers } from '../InternetOffersProvider';
import { hasDSLOffers, hasFWAOffers, hasOnlyFWAOffers } from '../util/InternetOfferUtil';
import { Notice, Separator } from 'telia-front-react';
export const OfferTechnologyNotices = () => {
    var _a;
    const { calculatorState } = useInternetOffers();
    const { translate } = React.useContext(TranslationsContext);
    if (!((_a = calculatorState.internetOffers) === null || _a === void 0 ? void 0 : _a.internetOfferCards.length) || !calculatorState.address) {
        return null;
    }
    if (hasOnlyFWAOffers(calculatorState.internetOffers)) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Separator, { spacing: 'xsmall', color: "invisible" }),
            React.createElement(Notice, { type: "attention" }, translate('secureNetCalculator.onlyFwaAvailable'))));
    }
    if (hasFWAOffers(calculatorState.internetOffers) && hasDSLOffers(calculatorState.internetOffers)) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Separator, { spacing: 'xsmall', color: "invisible" }),
            React.createElement(Notice, { type: "attention" }, translate('secureNetCalculator.noPonOffers'))));
    }
    return null;
};
